"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNotEmpty = exports.isEmpty = void 0;

function isEmpty(target, depth) {
  if (depth === void 0) {
    depth = 0;
  }

  if (typeof target === 'object') {
    if (depth > 0) {
      var values = Object.values(target);
      return values.length === 0 || values.every(function (value) {
        return isEmpty(value, depth - 1);
      });
    } else {
      var keys = Object.keys(target);
      return keys.length === 0;
    }
  }

  if (typeof target === 'number') {
    return isNaN(target);
  }

  if (typeof target === 'boolean') {
    return false;
  }

  return !target;
}

exports.isEmpty = isEmpty;

function isNotEmpty(target) {
  return !isEmpty(target);
}

exports.isNotEmpty = isNotEmpty;